export default "__VITE_ASSET__54c088c9__"